import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";
import { useTranslation } from "@/hooks/useTranslation";
import { translateUserHistoryAction } from "@/translation/user-history.translation";
import { UserHistoryDTO } from "@shaarp/common";
import { ColumnDef } from "@tanstack/react-table";
import DataTableCellUsersHistoryAvatar from "./data-table-cell-users-history-avatar";
import DataTableCellUsersHistoryTarget from "./data-table-cell-users-history-target";

export const dataTableUsersHistoryColumns = () => {
  const { t } = useTranslation();

  return [
    {
      id: "Utilisateur",
      accessorKey: "userId",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("components.dataTableUsersHistory.columns.user")}
        />
      ),
      cell: ({ cell }) => {
        const userHistory = cell.row.original as UserHistoryDTO;
        return <DataTableCellUsersHistoryAvatar userHistory={userHistory} />;
      },
    },
    {
      id: "Date",
      accessorKey: "date",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("components.dataTableUsersHistory.columns.date")}
        />
      ),
      cell: ({ cell }) => {
        const userHistory = cell.row.original as UserHistoryDTO;
        return new Date(userHistory.date).toLocaleString();
      },
    },
    {
      id: "Action",
      accessorKey: "action",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("components.dataTableUsersHistory.columns.action")}
        />
      ),
      cell: ({ cell }) => {
        const userHistory = cell.row.original as UserHistoryDTO;
        return translateUserHistoryAction(userHistory.action, t);
      },
    },
    {
      id: "Cible",
      accessorKey: "target",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("components.dataTableUsersHistory.columns.target")}
        />
      ),
      cell: ({ cell }) => {
        const userHistory = cell.row.original as UserHistoryDTO;
        return <DataTableCellUsersHistoryTarget userHistory={userHistory} />;
      },
    },
  ] as ColumnDef<UserHistoryDTO>[];
};
